import React from 'react';
import { Vehicle } from '@esportal/portal-service';
import { hasContract, longdriveProduct } from '../../../helpers/servicesHelper';
import { checkqueoDeCortesiaLayer } from './contentDetailLayers/checkeo-de-cortesia';
import { cocheDeSustitucionLayer } from './contentDetailLayers/coche-de-sustitucion';
import { expressServiceLayer } from './contentDetailLayers/express-service';
import { garantiaVolkswagenLayer } from './contentDetailLayers/garantia-volkswagen';
import { idCareLayer } from './contentDetailLayers/id-care';
import { itvPorTiLayer } from './contentDetailLayers/itv-pot-ti';
import { longDriveAdvanceLayer } from './contentDetailLayers/longdrive-advance';
import { longdriveNoContratadoLayer } from './contentDetailLayers/longdrive-no-contratado';
import { longDriveNoInformadoLayer } from './contentDetailLayers/longdrive-no-informado';
import { longdriveStandardLayer } from './contentDetailLayers/longdrive-standard';
import { preItvLayer } from './contentDetailLayers/pre-itv';
import { recogidaYentregaLayer } from './contentDetailLayers/recogida-y-entrega';
import { serviciosTallerLayer } from './contentDetailLayers/servicios-taller';
import { longDriveProLayer } from './contentDetailLayers/longdrive-pro';
import { IPortalContext } from '../../../context/PortalContext';

export enum ServiceType {
	AsistenciaCarretera = 'asistencia-carretera',
	LongDrive = 'long-drive',
	GarantiaVolkswagen = 'garantia-volkswagen',
	IdCare = 'id-care',
	RecogidaEntrega = 'recogida-entrega',
	CocheSustitucion = 'coche-sustitucion',
	ExpressService = 'express-service',
	Autoservicio = 'autoservicio',
	ITVporTi = 'itv-por-ti',
	CheckeoCortesia = 'checkeo-cortesia',
	PreItv = 'pre-itv',
}

export interface ServiceLayer {
	header: string;
	title: string;
	subtitle: JSX.Element;
	description?: JSX.Element;
	imageContent?: string;
	ctaText?: string;
	link?: string;
	descriptionFooter?: JSX.Element;
	imageFooter?: string;
}

export const defaultServiceLayer: ServiceLayer = {
	header: '',
	title: '',
	subtitle: <></>,
	description: <></>,
};

export const getServiceLayerData = (
	type: ServiceType,
	vehicle: Vehicle,
	portalContext: IPortalContext,
): ServiceLayer => {
	const { userInteractionService } = portalContext;

	switch (type) {
		case ServiceType.AsistenciaCarretera:
			return {
				header: '',
				title: '',
				subtitle: <></>,
			};
		case ServiceType.LongDrive: {
			if (hasContract(vehicle.longdrive?.contractEndDate)) {
				if (longdriveProduct(vehicle) === 'Standard') {
					return longdriveStandardLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Advance') {
					return longDriveAdvanceLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Pro') {
					return longDriveProLayer(userInteractionService);
				} else {
					return longDriveNoInformadoLayer;
				}
			} else {
				return longdriveNoContratadoLayer;
			}
		}
		case ServiceType.GarantiaVolkswagen:
			return garantiaVolkswagenLayer(vehicle);

		case ServiceType.IdCare:
			return idCareLayer;

		case ServiceType.RecogidaEntrega:
			return recogidaYentregaLayer;

		case ServiceType.CocheSustitucion:
			return cocheDeSustitucionLayer;

		case ServiceType.ExpressService:
			return expressServiceLayer;

		case ServiceType.Autoservicio:
			return serviciosTallerLayer;

		case ServiceType.ITVporTi:
			return itvPorTiLayer;

		case ServiceType.CheckeoCortesia:
			return checkqueoDeCortesiaLayer;

		case ServiceType.PreItv:
			return preItvLayer;

		default:
			return defaultServiceLayer;
	}
};
